import { T_ResourceCache } from '@cgs/wge';
import { CustomGamesResourceCache } from '@cgs/common';
import { ApplicationGameConfig } from '@cgs/shared';
import { TrifectaHudModule } from '@cgs/provider-trifecta';

export class CorsicaHudSdkModule extends TrifectaHudModule {
  public override async initialize(): Promise<void> {
    await this.loadPackage();
    await super.initialize();
  }

  // Просто костыль, чтобы подгрузить bottom ресурсы, так как там лежит пол игры
  private async loadPackage(): Promise<void> {
    const gameResourceCache = this.container.resolve<CustomGamesResourceCache>(T_ResourceCache);

    try {
      await gameResourceCache.loadPackage(`games/${ApplicationGameConfig.gameId}/bottom.zip`);
    } catch (error) {
      throw Error('Failed to load bottom.zip');
    }
  }
}
